import {Component, OnDestroy, OnInit, inject} from '@angular/core';
import {Subject, debounceTime, distinctUntilChanged, takeUntil} from 'rxjs';
import {FormFieldComponent} from '../shared/components/form-field/form-field.component';
import {ButtonPadraoComponent} from '../shared/components/button-padrao/button-padrao.component';
import {MatTableDataSource, MatTableModule} from '@angular/material/table';
import {MatDialog} from '@angular/material/dialog';
import {
  ModalCadastroVisualizacaoTemplateComponent
} from './modal-cadastro-visualizacao-template/modal-cadastro-visualizacao-template.component';
import {TemplateModel} from '../shared/model/template/template-model';
import {TemplateMensagemService} from '../shared/service/template-mensagem.service';
import {MsgService} from '../shared/service/msg.service';
import {DatePipe, NgStyle} from '@angular/common';
import {MatTooltip} from '@angular/material/tooltip';
import {StatusTemplateEnum} from '../shared/enum/status-template-enum';
import {ValidacaoAlteracaoCampoService} from '../shared/service/utilitarios/validacao-alteracao-campo.service';
import {TabelaSkeletonComponent} from '../shared/components/tabela-skeleton/tabela-skeleton.component';
import {CelularMaskPipe} from '../shared/pipe/celular-mask.pipe';
import {ModalFiltroTemplateComponent} from './modal-filtro-template/modal-filtro-template.component';
import {environment} from '../../../environments/environment';
import {DomSanitizer} from '@angular/platform-browser';
import {AuthService} from '../shared/service/auth.service';
import {TipoTemplateEnum} from '../shared/enum/tipo-template.enum';
import {CanalTemplateEnum} from '../shared/enum/canal-template.enum';
import { PageEvent } from '@angular/material/paginator';
import { PaginatorComponent } from '../shared/components/paginator/paginator.component';
import {ModalConfirmacaoComponent} from '../shared/modais/modal-confirmacao/modal-confirmacao.component';
import {Setor} from '../shared/model/setor/setor.model';
import {Ambiente} from '../shared/enum/ambiente.enum';
import {extrairMensagemErro} from '../shared/util/http-error.util';
import {ActivatedRoute} from '@angular/router';

@Component({
  selector: 'app-template',
  standalone: true,
  imports: [
    FormFieldComponent,
    ButtonPadraoComponent,
    MatTableModule,
    DatePipe,
    MatTooltip,
    TabelaSkeletonComponent,
    CelularMaskPipe,
    NgStyle,
    PaginatorComponent
  ],
  templateUrl: './template.component.html',
  styleUrl: './template.component.css'
})
export class TemplateComponent implements OnInit, OnDestroy {
  private readonly dialog = inject(MatDialog);
  private readonly templateService = inject(TemplateMensagemService);
  private readonly msgService = inject(MsgService);
  private readonly domSanitizer = inject(DomSanitizer);
  private readonly authService = inject(AuthService);
  private readonly alteracaoService = inject(ValidacaoAlteracaoCampoService);
  private readonly route = inject(ActivatedRoute);

  templates: TemplateModel[] = [];
  templateDataSource = new MatTableDataSource<TemplateModel>();
  templatesCarregando = false;
  templatesCarregados = false;
  displayedColumns: string[] = [ 'acao', 'id', 'nome', 'envioVia', 'conta', 'setor', 'status', 'statusMeta', 'tipo', 'usuCriacao', 'dataCriacao', 'dataAlteracao', 'usuAlteracao' ];
  filtro?: any;
  primeiraFiltragem = true

  //PAGINACAO
  page = 0;
  limit = 20;
  length = 0;

  isHml: boolean = environment.ambiente !== Ambiente.PROD;

  //ITENS DE FILTRO
  numero!: number[]
  tipo!: number[]
  tipoTemplate!: number[]
  status!: boolean[]
  statusMeta!: number[]
  setores?: Setor[];
  nomeFiltro?: string;

  private readonly destroy$ = new Subject<void>();
  private readonly buscaTexto$ = new Subject<string>();

  ngOnInit() {
    this.iniciarFiltragemTemplates(this.route.snapshot.queryParamMap.get('busca')?.trim() || undefined);

    this.buscaTexto$.pipe(
      debounceTime(400),
      distinctUntilChanged(),
      takeUntil(this.destroy$)
    ).subscribe(valor => {
      this.nomeFiltro = valor?.trim() || undefined;
      this.page = 0;
      this.buscarTemplatesFiltrado(this.montarFiltroAtual());
    });
  }

  ngOnDestroy() {
    this.destroy$.next();
    this.destroy$.complete();
  }

  private montarFiltroAtual() {
    return {
      numero: this.numero?.length ? this.numero : undefined,
      tipo: this.tipo?.length ? this.tipo : undefined,
      tipoTemplate: this.tipoTemplate?.length ? this.tipoTemplate : undefined,
      status: this.status,
      statusMeta: this.statusMeta?.length ? this.statusMeta : undefined,
      setores: this.setores,
      nome: this.nomeFiltro
    };
  }

  ehTemplateSms(elemento: any): boolean {
    return (elemento?.tipo || '').toUpperCase() === CanalTemplateEnum.SMS;
  }

  iniciarFiltragemTemplates(nomeInicial?: string) {
    this.status = [true];
    this.numero = [];
    this.tipo = [];
    this.tipoTemplate = [];
    this.statusMeta = [];
    this.setores = undefined;
    this.nomeFiltro = nomeInicial;
    this.filtro = { status: [true] };
    this.page = 0;
    this.buscarTemplatesFiltrado(this.montarFiltroAtual());
  }

  buscarTemplatesFiltrado(filtro: {
    numero?: number[],
    tipo?: number[],
    tipoTemplate?: number[],
    status?: boolean[],
    statusMeta?: number[],
    setores?: Setor[],
    nome?: string
  }) {
    this.templatesCarregando = true;
    this.templateService.buscarTemplatesFiltrado(filtro, this.page, this.limit).subscribe({
      next: res => {
        this.templatesCarregados = false;
        const templateRetorno: TemplateModel[] = [];
        res.content.forEach(template => {
          const tp = new TemplateModel();
          templateRetorno.push(tp.converterParaUsoInterno(template));
        });
        this.length = res.totalElements;

        this.templates = templateRetorno;
        this.templateDataSource.data = templateRetorno;
      },
      error: err => {
        this.msgService.msgErro(extrairMensagemErro(err, 'Não foi possível carregar os templates.'));
        this.templatesCarregados = true;
        this.templatesCarregando = false;
      },
      complete: () => {
        this.templatesCarregados= true;
        this.templatesCarregando = false;
      }
    });
  }

  filtrarTemplates(filtro: string) {
    this.buscaTexto$.next(filtro);
  }

  abrirModal(visualizar: boolean, template?: TemplateModel) {
    const bloqueadoPorUso = !!template?.utilizado && this.ehTemplateSms(template);
    visualizar = visualizar || bloqueadoPorUso;
    const templateEnvio = new TemplateModel(template?.id, template?.nome, template?.idioma, template?.categoria, template?.status, template?.dataCriacao, template?.usuarioAlteracao, template?.dataAlteracao, template?.usuarioAlteracao, template?.templateCabecalho, template?.variavel, template?.idRodape ,template?.textoRodape, template?.botoes, template?.conta, template?.ativo, template?.tipo, template?.utilizado);
    const edicao = template?.id != null;

    const dialogRef = this.dialog.open(ModalCadastroVisualizacaoTemplateComponent, {
      width: '381px', height: '100vh',
      position: {
        top: '0',
        right: '0'
      },
      data: { visualizar, edicao: edicao, template: templateEnvio },
      panelClass: 'slide-modal',
      disableClose: !visualizar
    })

    if (!visualizar) {
      dialogRef.backdropClick().subscribe(() => {
        const podeFechar = !this.alteracaoService.isCamposAlteracao() ||
          window.confirm('Pode possuir alterações não salvas, deseja fechar?');
        if (podeFechar) { dialogRef.close(); }
      });
    }

    dialogRef.afterClosed().subscribe({
      next: res => {
        if (res) {
          this.iniciarFiltragemTemplates();
        }
      }
    });
  }

  abrirModalFiltro() {
    this.dialog.open(ModalFiltroTemplateComponent, {
      width: '361px', height: '100vh',
      position: {
        top: '0',
        right: '0'
      },
      data: { filtro: this.filtro ?? null, primeiraFiltragem: this.primeiraFiltragem },
      panelClass: 'slide-modal'
    }).afterClosed().subscribe({
      next: res => {
        if (res) {
          this.filtro = res;
          this.primeiraFiltragem = false

          this.numero = [];
          if (res.numero && res.numero.length > 0) {
            res.numero.forEach((element: any) => {
               this.numero.push(element.id)
            });
          }

          this.tipo = [];
          if (res.tipo && res.tipo.length > 0) {
            res.tipo.forEach((element: any) => {
              this.tipo.push(Object.values(TipoTemplateEnum).indexOf(element))
            });
          }

          this.tipoTemplate = [];
          if (res.canal && res.canal.length > 0) {
            res.canal.forEach((element: any) => {
              this.tipoTemplate.push(Object.values(CanalTemplateEnum).indexOf(element.valor))
            });
          }

          this.statusMeta = [];
          if (res.statusMeta && res.statusMeta.length > 0) {
            res.statusMeta.forEach((element: any) => {
              this.statusMeta.push(Object.values(StatusTemplateEnum).indexOf(element))
            });
          }

          this.status = res.status;
          this.setores = res.setores;
          this.page = 0;

          this.buscarTemplatesFiltrado(this.montarFiltroAtual());
        }
      }
    });
  }

  gerarUrl(nomeArquivo: string, extensao: string, path: string) {
    return this.domSanitizer.bypassSecurityTrustUrl(`${environment.urlRepositorioClaribot}/${this.authService.getUsuarioLogado().grupo}/${path}/${nomeArquivo}.${extensao}`);
  }

  handlePageEvent(e: PageEvent) {
    this.page = e.pageIndex;
    this.limit = e.pageSize;
    this.buscarTemplatesFiltrado(this.montarFiltroAtual());
  }

  inativarTemplate(template: TemplateModel) {
    this.dialog.open(ModalConfirmacaoComponent, {
      data: { texto: 'Deseja inativar o template?' }
    }).afterClosed().subscribe({
      next: res => {
        if (res && template.id) {
          this.templateService.inativarTemplate(template.id).subscribe({
            next: () => {
              this.msgService.msgSucesso('Sucesso ao inativar o template.');
              this.iniciarFiltragemTemplates();
            }
          });
        }
      }
    });
  }
}
